import { useTracking } from '@change-corgi/core-react/tracking';

import { usePetitionGuidesPageData } from 'src/app/pages/petitionGuidesArticle/pageContext';
import type { ArticleContentType } from 'src/app/pages/petitionGuidesArticle/pageContext';

type Result = ModelHookResult<
	{
		coreArticles: ReadonlyArray<Readonly<ArticleContentType>>;
	},
	{
		trackArticleClick: () => void;
	}
>;

export function useLearnHowSection(): Result {
	const {
		data: {
			coreArticles,
			article: { slug },
		},
	} = usePetitionGuidesPageData();
	const track = useTracking();

	const filteredCoreArticles = coreArticles
		// Return all core articles, except for current article
		.filter((coreArticle) => coreArticle.slug !== slug);

	// Sort articles based on sortOrder from contentful
	const articlesBySortOrder = filteredCoreArticles.sort(
		(a, b) => (a.coreArticleSortBy ?? 0) - (b.coreArticleSortBy ?? 0),
	);

	return {
		data: {
			coreArticles: articlesBySortOrder,
		},
		actions: {
			trackArticleClick: () => {
				void track('petition_guides_article_learn_how_sidebar_click');
			},
		},
	};
}
